<script setup>
  import { computed } from 'vue';
  import { useGoToAppStore } from '@/composables/useGoToAppStore';
  import useUserGlobals from '@/composables/useUserGlobals';
  import useSettingsGlobals from '@/composables/useSettingsGlobals'

  const { $WEB_VIEW } = useSettingsGlobals()    

  const { $PRIMARY_ACTIVITY } = useUserGlobals();

  const appNames = {
		"kite": "iKitesurf",
		"windsurf": "iWindsurf",
		"sail": "SailFlow",
		"fish": "FishWeather"
	}

  const webLinks = {
		"kite": "https://wx.ikitesurf.com",
		"windsurf": "https://wx.iwindsurf.com",
		"sail": "https://wx.sailflow.com",
		"fish": "https://wx.fishweather.com"
	};

  const primaryActivity = computed(() => $PRIMARY_ACTIVITY ? $PRIMARY_ACTIVITY.toLowerCase() : null);
  const appName = computed(() => primaryActivity.value ? appNames[primaryActivity.value] : null);
  const webLink = computed(() => primaryActivity.value ? webLinks[primaryActivity.value] : null);

  const title = computed(() => {
    return primaryActivity.value 
            ? `Meet your new favorite weather app - ${appName.value}` 
            : 'Meet your new favorite weather app!'
  });

  const message = computed(() => {
    return primaryActivity.value 
            ? `All your favorite features, including our meteorologist-written PRO Forecasts, can now be found on ${appName.value}.`
            : 'It will start again in the spring.'
  });

  const handleMessageButtonClick = () => {
    useGoToAppStore(primaryActivity.value);
  }
</script>

<template>
  <div class="jwx-pro-forecast__message-block jwx-pro-forecast__app-referral-message">    
    <p class="jwx-pro-forecast__message-title" data-size="large">{{ title }}</p>
    <p class="jwx-pro-forecast__message-body">{{ message }}</p>
    <button 
      v-if="$WEB_VIEW"
      @click="handleMessageButtonClick"
      class="jwx-pro-forecast__message-button">
        Visit {{ appName }}
    </button>
    <a 
      v-else 
      :href="webLink" 
      class="jwx-pro-forecast__message-button" 
      target="_blank"
    >
      Visit {{ appName }}
    </a>
  </div>
</template>